import { render, staticRenderFns } from "./newStock.vue?vue&type=template&id=6753511e&scoped=true"
import script from "./newStock.vue?vue&type=script&lang=js"
export * from "./newStock.vue?vue&type=script&lang=js"
import style0 from "./newStock.vue?vue&type=style&index=0&id=6753511e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6753511e",
  null
  
)

export default component.exports